<template>
  <other-order :type="3"></other-order>
</template>
<script>
import otherOrder from "_my/other-order";
export default {
  name: "amazon",
  components: {
    otherOrder
  }
};
</script>
